module.exports = __webpack_public_path__ + "img/nft-placeholder.57fd05a9.svg";